import { useState } from 'react';
import { Icon, IconName } from '@/app/core/Svg';
import { Form, Input } from 'antd';
import { useTranslations } from 'next-intl';
import { useAppContext } from '@/app/core/AppContext';
import { proxy } from '@/lib/api/proxy';

export function Favorites() {
  const [form] = Form.useForm();
  const t = useTranslations();
  const context = useAppContext();
  const [formOpen, setFormOpen] = useState(false);
  const { me } = context || {};
  type Favorite = { id: number; url: string; iconId: IconName; title: string };
  const [favorites, setFavorites] = useState<Favorite[]>(me?.user?.favorites ?? []);

  const submit = async () => {
    const title = form.getFieldValue('title');
    if (!title) return;
    const url = window.location.href;
    const applications = me?.user?.customer?.applications ?? [];
    let applicationId = -1;
    const match = applications.find((app) => app.url === url);
    applicationId = match && match.id != null ? match.id : -1;
    const data = { title, url, userId: me?.user?.id, applicationId };
    try {
      const response = await fetch(proxy('sso', 'api/favorite'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });
      if (!response.ok) throw new Error('Failed to add favorite');
      // After successful add, fetch the updated favorites list
      const favResponse = await fetch(proxy('sso', 'api/favorite'));
      if (favResponse.ok) {
        const favList = await favResponse.json();
        setFavorites(favList ?? []);
      }
      form.resetFields();
      setFormOpen(false);
    } catch (err) {
      // TODO: Handle error (show notification, etc.)
      console.error(err);
    }
  };

  return (
    <div>
      <div className="sidebar-item">
        <p className="heading">{t('FAV_LINKS')}</p>
        <ul>
          {favorites.map((app) => (
            <li key={app.id}>
              <a href={app.url}>
                <div className="icon">
                  <Icon key={app.iconId} name={app.iconId as IconName} size={32} />
                </div>
                <div className="name">{app.title}</div>
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="sidebar-item favorites-form">
        <div className="item" onClick={() => setFormOpen(!formOpen)}>
          <div className="icon">
            <i className="fa-solid fa-star"></i>
          </div>
          <span>{t('ADD_PAGE_TO_FAV')}</span>
        </div>
        <Form className={`form${formOpen ? ' open' : ''}`} onFinish={submit} layout="vertical" form={form}>
          <Form.Item className="form-item" label={t('LINK_TITLE')} name="title">
            <Input type="text" />
          </Form.Item>
          <button type="button" className="btn btn-cancel" onClick={() => setFormOpen(false)}>
            {t('CANCEL')}
          </button>
          <button type="submit" className="btn btn-confirm">
            {t('ADD')}
          </button>
        </Form>
      </div>
    </div>
  );
}
